import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LobbyDetailViewComponent } from './lobby-detail-view/lobby-detail-view.component';
import {FiltersComponent} from './filters/filters.component';
import { LobbyEditorComponent } from './lobby-editor/lobby-editor.component';
import { LobbyDataViewComponent } from './lobby-data-view/lobby-data-view.component';

const routes: Routes = [
  { path: '', component: LobbyDetailViewComponent },
  { path: 'lobby-detail-view', component: LobbyDetailViewComponent },
  { path: 'filters', component: FiltersComponent },
  { path: 'lobby-editor', component: LobbyEditorComponent},
  { path: 'lobby-data-view', component: LobbyDataViewComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
